import {Injectable} from '@angular/core';
import {LocalUsuarioRepository} from "../../data/datasource/local/usuario/local.usuario.repository";
import {Usuario} from "../models/usuario.model";
import {EmpresaEntity} from "../entity/empresa.entity";

@Injectable({
    providedIn: 'root'
})
export class SecurityService {

    constructor(
        private localUsuarioRepository: LocalUsuarioRepository
    ) {
    }

    public existeSesion() {
        const token = this.localUsuarioRepository.obtenerToken();
        // tslint:disable-next-line:triple-equals
        return token && token != '';
    }

    public getToken() {
        return this.localUsuarioRepository.obtenerToken();
    }

    public usuarioLogeado(): Usuario {
        return this.localUsuarioRepository.obtenerUsuarioSesion();
    }

    public empresaSession(): any {
        return this.localUsuarioRepository.obtenerEmpresaSesion();
    }

    public guardarEmpresaSesion(empresa: EmpresaEntity): any {
        return this.localUsuarioRepository.guardarEmpresaSesion(empresa);
    }
    public empresaList(): any {
        return this.localUsuarioRepository.obtenerEmpresasListSesion();
    }

    public checkPermission(permissioncodes: any[]): boolean {
        return this.localUsuarioRepository.checkPermission(permissioncodes);
    }

    public localIdSesion(): string {
        const usuarioLogeado: any = this.usuarioLogeado();
        if (usuarioLogeado) {
            return usuarioLogeado.local_id;
        }
    }


}

